import { jsx } from 'react/jsx-runtime';
import { forwardRef, useMemo } from 'react';
import { Slider } from '../slider/slider.js';
import { resolveOpacityColor } from './opacity-slider.color.js';
import { makeOpacitySliderStyle } from './opacity-slider.utils.js';

/**
 * A slider for adjusting the opacity of a color. Built on {@link Slider}, with a checkerboard
 * track that fades the color from transparent to opaque.
 * @see https://fpl.figma.design/components/opacity-slider/
 */
const OpacitySlider = forwardRef(({ color, value, colorSpace = 'srgb', size = 'md', ...props }, ref) => {
    // A string color is resolved to channels via a canvas; memoize so a drag (which only
    // changes `value`) doesn't re-resolve it every frame.
    const resolved = useMemo(() => resolveOpacityColor(color, colorSpace), [color, colorSpace]);
    return (jsx(Slider, { "data-fpl-component": "", ...props, ref: ref, size: size, min: 0, max: 1, step: 0.01, bigStep: 0.1, value: value, 
        // The slider works in [0, 1]; announce a friendlier percentage to screen readers.
        valueText: `${Math.round(value * 100)}%`, style: makeOpacitySliderStyle(resolved.rgb, value, resolved.colorSpace, size) }));
});
OpacitySlider.displayName = 'OpacitySlider';

export { OpacitySlider };
//# sourceMappingURL=opacity-slider.js.map
